import {useNavigate} from "react-router-dom";
import {useState, useContext} from "react";
import {AuthContext} from "../contexts/AuthContext";

const Login = () => {
    const navigate = useNavigate();
    const apiUrl = process.env.REACT_APP_API || '';
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [step, setStep] = useState(0); // 0 = credentials, 1 = enter 2fa
    const [code, setCode] = useState('');
    const [isWaitingAuth, setIsWaitingAuth] = useState(false);

    const { me, setSuspendRedirects } = useContext(AuthContext);

    const waitForMe = async (attempts = 6, initialDelay = 300) => {
        let delay = initialDelay;
        for (let i = 0; i < attempts; i++) {
            // use silent mode to avoid toggling global loading UI
            const u = await me({ silent: true });
            console.debug(`waitForMe attempt ${i + 1}/${attempts} -> user=${u ? 'present' : 'null'}`);
            if (u) return u;
            await new Promise(r => setTimeout(r, delay));
            delay = Math.min(2000, delay * 2);
        }
        return null;
    };

    const submitCredentials = async () => {
        try {
            const res = await fetch(apiUrl + '/branduser/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ email, password }),
            });
            const data = await res.json();
            if (!res.ok) {
                alert(data.message || 'Erreur lors de la connexion');
                return;
            }
            // If API requests 2FA, show code input step
            if (data?.twoFaRequired || data?.status === '2fa_sent' || data?.message === '2fa_sent') {
                setStep(1);
                return;
            }
            // If already authenticated
            if (data?.success) {
                // suspend redirects while server sets cookie and /me is updated
                try {
                    setSuspendRedirects(true);
                    setIsWaitingAuth(true);
                    const u = await waitForMe();
                    setIsWaitingAuth(false);
                    if (u) {
                        navigate('/dashboard');
                        return;
                    }
                    // fallback: still navigate but AuthContext will handle redirect if unauthenticated
                    navigate('/dashboard');
                } finally {
                    // small grace period to let cookies/session settle and AuthContext stabilize
                    setTimeout(() => setSuspendRedirects(false), 800);
                    setIsWaitingAuth(false);
                }
            } else {
                alert(data.message || 'Échec de la connexion');
            }
        } catch (err) {
            console.error(err);
            alert('Impossible de contacter le serveur.');
        }
    };

    const submit2fa = async () => {
        try {
            const res = await fetch(apiUrl + '/branduser/verify-2fa', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ email, code }),
            });
            const data = await res.json();
            if (res.ok && data.success) {
                // suspend redirects while cookie is applied and /me reflects auth
                try {
                    setSuspendRedirects(true);
                    setIsWaitingAuth(true);
                    const u = await waitForMe();
                    setIsWaitingAuth(false);
                    if (u) {
                        navigate('/dashboard');
                        return;
                    }
                    // last resort: navigate anyway
                    navigate('/dashboard');
                } finally {
                    // small grace period to let cookies/session settle and AuthContext stabilize
                    setTimeout(() => setSuspendRedirects(false), 800);
                    setIsWaitingAuth(false);
                }
            } else {
                alert(data.message || 'Code 2FA invalide');
            }
        } catch (err) {
            console.error(err);
            alert('Impossible de contacter le serveur.');
        }
    };

    if (step === 1) {
        return <form className="form" onSubmit={async (e) => {
            e.preventDefault();
            await submit2fa();
        }}>
            <div className="input-group">
                <label>Code 2FA envoyé par e-mail</label>
                <input value={code} onChange={e => setCode(e.target.value)} required type="text" placeholder="Code 2FA"/>
            </div>
            {/*<div className="input-group checkboxes">*/}
            {/*    <input type="checkbox" id="remember-me" name="remember-me"/>*/}
            {/*    <label htmlFor="remember-me">Rester connecté</label>*/}
            {/*</div>*/}
            <button type="submit">Valider</button>
            {isWaitingAuth && <p style={{marginTop:8}}>Vérification en cours, merci de patienter...</p>}
        </form>
    }

    return <form className="form" onSubmit={async (e) => {
        e.preventDefault();
        await submitCredentials();
    }}>
        <div className="input-group">
            <label>Adresse e-mail</label>
            <input value={email} onChange={e => setEmail(e.target.value)} required type="email" placeholder="Adresse e-mail"/>
        </div>
        <div className="input-group">
            <label>Mot de passe</label>
            <input value={password} onChange={e => setPassword(e.target.value)} required type="password" placeholder="Mot de passe"/>
        </div>
        <button type="submit">Connexion</button>
        {isWaitingAuth && <p style={{marginTop:8}}>Connexion en cours, vérification...</p>}
    </form>
}

export default Login;